import React from 'react'
import { useTranslation } from 'react-i18next'
import { DashboardWidget } from 'features/widget/types'
import { WidgetGuard } from 'features/types'
import { useDashboardWidgetData } from 'hooks/useWidgetState'
import { AnnotatedMetricResult } from 'schemas/AnnotatedMetricResultSchema'
import ErrorMessage from '../../../share/ErrorMessage'
import { languageNotSupported } from '../utils/languageNotSupportedChecker'

const isAllLanguageNotSupported = (widgetData: DashboardWidget<AnnotatedMetricResult>) =>
  widgetData.data.every(languageNotSupported)

const LanguageNotSupportedGuard: WidgetGuard = ({ widgetId, children }) => {
  const widgetData = useDashboardWidgetData<AnnotatedMetricResult>(widgetId)
  const { t } = useTranslation()

  if (isAllLanguageNotSupported(widgetData)) {
    return <ErrorMessage>{t('topicLanguageUnsupported')}</ErrorMessage>
  }

  return children
}

export default LanguageNotSupportedGuard
